/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useEffect, useState } from "react";
import {
  MenuItem,
  Button,
  Snackbar,
  Alert,
  Menu,
  Tooltip,
  Box,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import {
  Add as AddIcon,
  KeyboardArrowDown as KeyboardArrowDownIcon,
  VpnKey as VpnKeyIcon,
  Campaign as CampaignIcon,
  Google as GoogleIcon,
  travel_explore as BingIcon, // Using travel_explore as generic for Bing if custom icon not available
  ArrowRight as ArrowRightIcon,
  TravelExplore,
} from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import GroupSetting from "./GroupSetting";
import axios from "axios";
import { apiRequestBodyBuilder } from "../config/tableHelper";

const CampaignLevel = () => {
  const [subGroups, setSubGroups] = useState([]);
  const [categories, setCategories] = useState([]);
  const [selectedSubGroupId, setSelectedSubGroupId] = useState("");
  const [groupOptions, setGroupOptions] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("");
  const [selectedGroupId, setSelectedGroupId] = useState("");
  const [snackbarError, setSnackbarError] = useState("");
  const navigate = useNavigate();
  const email = localStorage.getItem("email") || "malisanket882@gmail.com";
  const customer_id = localStorage.getItem("customer_id");

  // --- Menu State Management ---
  const [anchorEl, setAnchorEl] = useState(null); // Main menu (Create New Group)
  const [googleAnchorEl, setGoogleAnchorEl] = useState(null); // Sub-menu for Google
  const [bingAnchorEl, setBingAnchorEl] = useState(null); // Sub-menu for Bing

  const isMenuOpen = Boolean(anchorEl);
  const isGoogleMenuOpen = Boolean(googleAnchorEl);
  const isBingMenuOpen = Boolean(bingAnchorEl);

  // Open Main Menu
  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  // Open Sub Menus
  const handleGoogleMenuOpen = (event) => {
    setGoogleAnchorEl(event.currentTarget);
  };

  const handleBingMenuOpen = (event) => {
    setBingAnchorEl(event.currentTarget);
  };

  // Close All Menus
  const handleMenuClose = () => {
    setAnchorEl(null);
    setGoogleAnchorEl(null);
    setBingAnchorEl(null);
  };

  const [refreshCounter, setRefreshCounter] = useState(Math.random());

  const [currentGroupType, setCurrentGroupType] = useState("campaign"); // keyword, campaign

  const fetchCurrentGroupType = () => {
    let ReqBody = apiRequestBodyBuilder()
    axios
      .post("https://api.confidanto.com/campaign-group2/group-info", ReqBody)
      .then((res) => {
        setCurrentGroupType(res.data.type);
        console.info(res.data);
      })
      .catch((err) => {
        console.error("ERROR FETCHING GROUP TYPE");
      });
  };

  // UPDATED: Accepts engine and adds it to URL params
  const handleCreateGroupRedirect = (groupType, engine) => {
    // Navigate with query param ?engine=...
    navigate(`/google-ads/CreateGroup?engine=${engine}`, {
      state: { groupType: groupType },
    });
    handleMenuClose();
  };

  const fetchGroups = useCallback(async () => {
    try {
      let requestBody = apiRequestBodyBuilder();

      const response = await fetch(
        "https://api.confidanto.com/campaign-group/fetch-groups",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(requestBody),
        },
      );
      const data = await response.json();
      setGroupOptions(data.groups || []);
    } catch (err) {
      console.error("Failed to fetch groups", err);
    }
  }, []);

  useEffect(() => {
    fetchCurrentGroupType();
    fetchGroups();
    if (selectedGroupId) {
      fetchSubGroups(selectedGroupId);
    }
  }, [selectedGroupId, refreshCounter]);

  const fetchSubGroups = async (groupId) => {
    try {
      const response = await fetch(
        "https://api.confidanto.com/sub-channel/fetch-sub-channels",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            customer_id: localStorage.getItem("customer_id"),
            group_id: groupId,
            email: localStorage.getItem("email") || "malisanket882@gmail.com",
          }),
        },
      );
      const data = await response.json();
      setSubGroups(Array.isArray(data) ? data : []);
    } catch (error) {
      console.error("Error fetching sub-groups:", error);
      setSubGroups([]);
    }
  };

  const fetchCategories = useCallback(async () => {
    if (!selectedGroupId || !selectedSubGroupId || selectedCategory) return;

    try {
      const response = await fetch(
        "https://api.confidanto.com/category/fetch-categories",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            email,
            group_id: selectedGroupId,
            sub_channel_id: selectedSubGroupId,
            category_id: selectedCategory,
            customer_id,
          }),
        },
      );

      const data = await response.json();
      if (Array.isArray(data)) {
        setCategories(data);
      } else {
        setCategories([]);
      }
    } catch (error) {
      console.error("Error fetching categories:", error);
      setCategories([]);
    }
  }, [
    selectedGroupId,
    selectedSubGroupId,
    selectedCategory,
    email,
    customer_id,
  ]);

  useEffect(() => {
    if (selectedGroupId && selectedSubGroupId) {
      fetchCategories();
    }
  }, [selectedGroupId, selectedSubGroupId, fetchCategories]);

  const isKeywordDisabled = currentGroupType === "campaign";
  const isCampaignDisabled = currentGroupType === "keyword";

  const keywordTooltipText =
    "User can only create one type of group. Delete existing groups to create a keyword group.";
  const campaignTooltipText =
    "User can only create one type of group. Delete existing groups to create a campaign group.";

  const platforms = JSON.parse(
    localStorage.getItem("platform_connected") || "{}",
  );
  const showGoogleAdsButton = !!platforms?.google_ads;
  const showMicrosoftAdsButton = !!platforms?.microsoft_ads;

  // Helper to render the specific Keyword/Campaign items
  const renderSubMenuItems = (engine) => (
    <Box>
      <Tooltip
        title={isKeywordDisabled ? keywordTooltipText : ""}
        placement="right"
      >
        <div>
          <MenuItem
            onClick={() => handleCreateGroupRedirect("keyword", engine)}
            disabled={isKeywordDisabled}
            sx={{ width: 220, gap: 1.5 }}
          >
            <VpnKeyIcon fontSize="small" />
            Keyword Group
          </MenuItem>
        </div>
      </Tooltip>
      <Tooltip
        title={isCampaignDisabled ? campaignTooltipText : ""}
        placement="right"
      >
        <div>
          <MenuItem
            onClick={() => handleCreateGroupRedirect("campaign", engine)}
            disabled={isCampaignDisabled}
            sx={{ width: 220, gap: 1.5 }}
          >
            <CampaignIcon fontSize="small" />
            Campaign Group
          </MenuItem>
        </div>
      </Tooltip>
    </Box>
  );

  return (
    <div style={{ padding: 24 }} className="mb-64 ">
      <Box sx={{ display: "flex", mb: 4 }}>
        <Button
          variant="contained"
          onClick={handleMenuOpen}
          startIcon={<AddIcon />}
          endIcon={<KeyboardArrowDownIcon />}
          id="create-group-button"
          aria-controls={isMenuOpen ? "create-group-menu" : undefined}
          aria-haspopup="true"
          aria-expanded={isMenuOpen ? "true" : undefined}
          sx={{ textTransform: "none", fontWeight: "bold" }}
        >
          Create New Group
        </Button>
      </Box>

      {/* --- LEVEL 1 MENU: Engines --- */}
      <Menu
        id="create-group-menu"
        anchorEl={anchorEl}
        open={isMenuOpen}
        onClose={handleMenuClose}
        MenuListProps={{
          "aria-labelledby": "create-group-button",
        }}
        PaperProps={{
          elevation: 2,
          sx: {
            overflow: "visible",
            filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
            mt: 1.5,
          },
        }}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
      >
        {/* Google Ads Option */}
        {showGoogleAdsButton && (
          <MenuItem onClick={handleGoogleMenuOpen} sx={{ width: 220 }}>
            <ListItemIcon>
              <GoogleIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText>Google Ads</ListItemText>
            <ArrowRightIcon fontSize="small" />
          </MenuItem>
        )}

        {/* Bing Option */}
        {showMicrosoftAdsButton && (
          <MenuItem onClick={handleBingMenuOpen} sx={{ width: 220 }}>
            <ListItemIcon>
              <TravelExplore fontSize="small" />
            </ListItemIcon>
            <ListItemText>Bing</ListItemText>
            <ArrowRightIcon fontSize="small" />
          </MenuItem>
        )}
      </Menu>

      {/* --- LEVEL 2 MENU: Google Sub-options --- */}
      <Menu
        id="google-sub-menu"
        anchorEl={googleAnchorEl}
        open={isGoogleMenuOpen}
        onClose={handleMenuClose} // Close all when clicking outside
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        PaperProps={{
          elevation: 2,
          sx: { mt: 0, ml: 1 }, // slight offset
        }}
      >
        {renderSubMenuItems("google_ads")}
      </Menu>

      {/* --- LEVEL 2 MENU: Bing Sub-options --- */}
      <Menu
        id="bing-sub-menu"
        anchorEl={bingAnchorEl}
        open={isBingMenuOpen}
        onClose={handleMenuClose} // Close all when clicking outside
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        PaperProps={{
          elevation: 2,
          sx: { mt: 0, ml: 1 }, // slight offset
        }}
      >
        {renderSubMenuItems("bing_ads")}
      </Menu>

      <GroupSetting
        groupType={currentGroupType}
        setRefreshCounter={setRefreshCounter}
      />
      <Snackbar
        open={!!snackbarError}
        autoHideDuration={4000}
        onClose={() => setSnackbarError("")}
      >
        <Alert severity="error">{snackbarError}</Alert>
      </Snackbar>
    </div>
  );
};

export default CampaignLevel;
